module.exports = __webpack_public_path__ + "img/logout.59ca2f23.svg";